import { createClient } from '@supabase/supabase-js'

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY
const supabaseSvcKey  = process.env.REACT_APP_SUPABASE_SERVICE_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Admin client — uses service key from environment variable ONLY
// NEVER hardcode the service key here!!
export const supabaseAdmin = createClient(supabaseUrl, supabaseSvcKey || supabaseAnonKey)

export const LCA_FEE      = 25
export const LCA_FLAT_FEE = 25

// ✅ Fetch active services from database — all-inclusive pricing!!
export async function fetchServices() {
  const { data } = await supabase.from('services').select('*').eq('is_active', true).order('category').order('name')
  return data || []
}

// ✅ Build a fees map from services for backward compatibility
export function buildFeesMap(services) {
  return services.reduce((acc, s) => { acc[s.name] = s.client_price; return acc }, {})
}

export const SIGNING_FEES = {
  'Buyer Closing Package':    225,
  'Refinance Package':        175,
  'HELOC Package':            150,
  'Reverse Mortgage':         275,
  'Loan Modification':        125,
  'Seller Closing Package':   150,
  'Power of Attorney':        150,
  'Affidavit (General)':       35,
  'Acknowledgement':           35,
  'Jurat / Oath':              35,
  'Name Change Affidavit':     35,
  'Residency Affidavit':       45,
  'Identity Affidavit':        45,
  'Lost Documents Affidavit':  55,
  'Financial Affidavit':       75,
  'Heirship Affidavit':       175,
  'Estate Affidavit':         175,
  'Travel Consent (Minor)':   100,
  'Adoption Documents':       175,
  'Guardianship Affidavit':   150,
  'Hospital / Bedside':       175,
  'Banking Forms':             75,
  'Pension / Retirement':     125,
  'Promissory Note':          125,
  'Lease Agreement':          100,
  'Bill of Sale':              75,
  'DMV Forms':                 75,
  'Passport Forms':            75,
  'Vehicle Title Transfer':   100,
  'Vehicle Purchase Contract':100,
  'Apostille':                200,
  'Certified Copies':         100,
  'Signature Witnessing':      75,
  'Wedding Officiation':      200,
  'Scanbacks':                 35,
}

export function getRank(signings) {
  if (signings >= 1000) return 'Elite'
  if (signings >= 500)  return 'Platinum'
  if (signings >= 250)  return 'Gold'
  if (signings >= 100)  return 'Silver'
  if (signings >= 50)   return 'Bronze'
  return 'Rising'
}

export function getNotaryRank(signings) { return getRank(signings) }

export function getNextRank(signings) {
  if (signings < 50)   return { next:'Bronze',   threshold:50   }
  if (signings < 100)  return { next:'Silver',   threshold:100  }
  if (signings < 250)  return { next:'Gold',     threshold:250  }
  if (signings < 500)  return { next:'Platinum', threshold:500  }
  if (signings < 1000) return { next:'Elite',    threshold:1000 }
  return { next:'Elite', threshold:1000 }
}

export function getNextRankThreshold(signings) { return getNextRank(signings) }

// ✅ Badge PNG URLs
export const RANK_BADGES = {
  Bronze:   'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/credentials/badge-bronze.png',
  Silver:   'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/credentials/badge-silver.png',
  Gold:     'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/credentials/badge-gold.png',
  Platinum: 'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/credentials/badge-platinum.png',
  Elite:    'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/credentials/badge-elite.png',
}
